import React from "react";
import { Link } from "react-router-dom";
import Header from "../components/Header";
import Footer from "../components/Footer";
import "../css/NewsletterPage.css";

const NewsletterPage = () => {
  return (
    <>
      <Header />
      <div className="newsletter-page">
        <div
          className="newsletter-banner"
          style={{
            backgroundImage:
              "url('/wp-content/uploads/2016/02/annual-reports.jpg')",
          }}
        ></div>

        <div className="newsletter-content">
          <div className="newsletter-breadcrumb">
            <Link to="/">Home</Link> &gt;{" "}
            <span className="current">Newsletter</span>
          </div>

          <h1 className="newsletter-title">Newsletter</h1>

          <div className="newsletter-two-columns">
            {/* Left column – Company Profile image */}
            <div className="newsletter-left">
              <h5>COMPANY PROFILE</h5>
              <div className="newsletter-image-wrapper">
                <a
                  href="/wp-content/uploads/2024/04/Colombo Dockyard Company Profile.pdf"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <img
                    src="/wp-content/uploads/2024/04/image.png"
                    alt="Company Profile"
                  />
                </a>
              </div>
            </div>

            {/* Right column – PDF links with custom icons */}
            <div className="newsletter-right">
              <div className="pdf-link">
                <a
                  href="/wp-content/uploads/2024/04/Colombo Dockyard Company Profile.pdf"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i className="fas fa-building"></i> Company Profile
                </a>
              </div>
              <div className="pdf-link">
                <a
                  href="/wp-content/uploads/2024/04/Afloat-Repair-Brochure-March-2024.pdf"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i className="fas fa-ship"></i> Rapid Response Afloat Repair
                </a>
              </div>
              <div className="pdf-link">
                <a
                  href="/wp-content/uploads/2024/08/ColDock_Whiz_50th_Anniversary_Edition.pdf"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i className="fas fa-newspaper"></i> COLDOCK WHIZ ANNIVERSARY
                  EDITION
                </a>
              </div>
              <div className="pdf-link">
                <a
                  href="/wp-content/uploads/2024/04/Why Colombo Dockyard 2025.pdf"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i className="fas fa-question-circle"></i> WHY COLOMBO
                  DOCKYARD
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
};

export default NewsletterPage;
